import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { DropdownFilter, DropdownSelect, useDropdown } from 'shared/components/DropdownFilter';
import { useFilterChangeCallback, useShowSearchMetaTooltip } from 'shared/hooks';
import { selectSpecialtyTypesFilter } from 'shared/selectors/filters/specialtyTypes';
import { selectIsInlineFiltersRedesigned } from 'shared/selectors/redesigned/selectIsInlineFiltersRedesigned';
import { TSelectValue } from 'shared/types/filters';

import { FILTER_KEY } from './constants';

export const SpecialtyTypesContainer: FC = () => {
  const { label, value, options } = useSelector(selectSpecialtyTypesFilter);
  const isFiltersRedesignEnabled = useSelector(selectIsInlineFiltersRedesigned);

  const dropdownState = useDropdown(FILTER_KEY);
  const showTooltip = useShowSearchMetaTooltip(FILTER_KEY);

  const onChange = useFilterChangeCallback(FILTER_KEY);

  const handleChange = useCallback(
    (next: TSelectValue) => {
      const nextValue = Array.isArray(next) ? (next as number[]) : null;
      onChange({ action: 'setSpecialtyTypes', arguments: [nextValue && nextValue.length ? nextValue : null] });
    },
    [onChange],
  );

  // TODO [COMMERCIAL-MIGRATION]: опции подгружаются на Stage F. До этого — скрываем фильтр.
  if (options.length === 0) {
    return null;
  }

  return (
    <DropdownFilter
      {...dropdownState}
      buttonLabel={label}
      showTooltip={showTooltip}
      isFiltersRedesignEnabled={isFiltersRedesignEnabled}
      dropdownContent={<DropdownSelect multiple options={options} value={value} onChange={handleChange} />}
    />
  );
};
